import { ShieldAlert } from "lucide-react";

export function OrganizationContextUnavailable() {
  return (
    <div className="mx-auto max-w-2xl rounded-2xl border border-[#e3c47b] bg-[#fff7df] p-6 text-[#6c5016] shadow-[0_7px_22px_rgba(23,79,57,0.04)] sm:p-8">
      <ShieldAlert className="h-6 w-6" />
      <h1 className="mt-5 font-heading text-2xl font-bold">Organization access required</h1>
      <p className="mt-2 font-body text-sm leading-6">
        This Client Portal view needs an organization-scoped administrator account. Platform team members must enter through explicit organization impersonation.
      </p>
    </div>
  );
}
